<template>
    <div class="cert-off-notice" v-if="certification">
        <ui-card>
            <div class="columns is-vcentered is-mobile">
                <div class="column is-narrow">
                    <i class="fad fa-toggle-off fa-2x has-text-grey-light"></i>
                </div>
                <div class="column">
                    <div class="has-text-weight-bold">{{ certification.certification.title }} is turned off</div>
                    <div class="has-text-grey is-size-6"><slot/></div>
                </div>
                <div class="column is-narrow">
                    <b-button type="is-primary" size="is-small" tag="router-link" :to="{name: 'account', params: {section: 'certs'}}"><i class="far fa-toggle-on mr-2"></i>Turn On</b-button>
                </div>
            </div>
        </ui-card>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import UiCard from "../UiCard";

    // One-line nudge shown in place of a certification's dashboard section
    // while that certification is switched off but the account holds work
    // for it (courses offering clock hours, WIAA registrations, …). Nothing
    // is hidden from the user's records; only the tools wait for the switch.
    export default {
        name: "CertificationOffNotice",
        components: {UiCard},
        props: {
            certificationId: {type: Number, required: true},
        },
        computed: {
            ...mapGetters(['certificationById']),
            certification() {
                return this.certificationById(this.certificationId);
            },
        },
    };
</script>
